"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icon_size_enum_1 = __importDefault(require("../enums/icon-size.enum"));
var size_extended_enum_1 = __importDefault(require("../enums/size-extended.enum"));
/**
 * @function getIconEnumValue
 * @param {SizeEnum | SizeExtendedEnum | undefined} enumObject enum to get the value from
 * @description Returns icon enum value
 * @returns {string} any
 */
var getIconEnumValue = function (enumObject) {
    var value = String(enumObject || size_extended_enum_1.default.X1);
    var chars = value.split("");
    if (parseInt(chars[0], 10)) {
        value = "".concat(chars[1]).concat(chars[0]);
    }
    return icon_size_enum_1.default[value.toUpperCase()];
};
exports.default = getIconEnumValue;
